import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from './MarketingLayout';

const COMPARE = [
  { feature: 'Real-time IP blocking',          cs: true,   cc: true,   fb: true,   manual: false },
  { feature: 'Google Ads API integration',     cs: true,   cc: true,   fb: true,   manual: false },
  { feature: '7-day free trial',               cs: true,   cc: true,   fb: true,   manual: false },
  { feature: 'No long-term contracts',         cs: true,   cc: false,  fb: false,  manual: true  },
  { feature: 'Transparent pricing',            cs: true,   cc: false,  fb: true,   manual: true  },
  { feature: 'Starting price',                 cs: '$69',  cc: '$89',  fb: '$79',  manual: 'Free' },
  { feature: 'Unlimited clicks plan',          cs: true,   cc: false,  fb: false,  manual: false },
  { feature: 'Custom detection rules',         cs: true,   cc: true,   fb: false,  manual: false },
  { feature: 'Clean modern dashboard',         cs: true,   cc: true,   fb: true,   manual: false },
  { feature: 'Invoice email on every payment', cs: true,   cc: false,  fb: false,  manual: false },
  { feature: 'Annual billing discount',        cs: true,   cc: true,   fb: false,  manual: false },
  { feature: 'GDPR compliant',                 cs: true,   cc: true,   fb: true,   manual: false },
];

const REASONS = [
  { icon: '⚡', title: 'Faster Blocking', desc: 'Fraudulent IPs are pushed to Google Ads exclusions in under 1 second. Competitors can take minutes or longer.' },
  { icon: '💰', title: 'Better Value', desc: 'Starting at $69/month with an unlimited clicks plan available. No hidden fees or per-click charges.' },
  { icon: '📊', title: 'Deeper Analytics', desc: 'See fraud broken down by IP, device, location, ISP, time of day — not just totals.' },
  { icon: '🔒', title: 'Privacy First', desc: 'GDPR compliant from day one. IP addresses pseudonymized after 30 days. Your data stays yours.' },
  { icon: '🚀', title: '5-Minute Setup', desc: 'One script tag. No developer needed. No OAuth flows. No complex API configurations.' },
  { icon: '🛠️', title: 'Custom Rules', desc: 'Advanced plan users can create custom fraud detection rules tuned to their specific industry and traffic patterns.' },
];

function Cell({ v }) {
  if (v === true)  return <span style={{ color: '#22c55e', fontWeight: 700, fontSize: 16 }}>✓</span>;
  if (v === false) return <span style={{ color: '#e2e8f0', fontSize: 16 }}>—</span>;
  return <span style={{ fontSize: 13, color: '#475569', fontWeight: 600 }}>{v}</span>;
}

export default function WhyUs() {
  return (
    <MarketingLayout>
      {/* Hero */}
      <section style={{ padding: '80px 24px 60px', background: 'linear-gradient(180deg,#f8faff 0%,#fff 100%)', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: '#f0fdf4', color: '#059669', fontSize: 12, fontWeight: 700, letterSpacing: '1.2px', textTransform: 'uppercase', padding: '5px 14px', borderRadius: 40, border: '1px solid #bbf7d0', marginBottom: 20 }}>Why ClickSaver?</div>
        <h1 style={{ fontSize: 48, fontWeight: 900, letterSpacing: '-2px', marginBottom: 16, lineHeight: 1.1 }}>The smarter choice for<br />click fraud protection</h1>
        <p style={{ fontSize: 18, color: '#475569', maxWidth: 520, margin: '0 auto' }}>Powerful protection, fair pricing, and a dashboard you'll actually enjoy using.</p>
      </section>

      {/* Reasons */}
      <section style={{ padding: '60px 24px 80px', background: '#fff' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
            {REASONS.map((r, i) => (
              <div key={i} style={{ padding: '28px 24px', background: '#f8fafc', borderRadius: 16, border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: 32, marginBottom: 14 }}>{r.icon}</div>
                <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 8 }}>{r.title}</h3>
                <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.7 }}>{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparison table */}
      <section style={{ padding: '20px 24px 100px', background: '#f8fafc' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, textAlign: 'center', letterSpacing: '-1px', marginBottom: 12 }}>How we compare</h2>
          <p style={{ fontSize: 16, color: '#64748b', textAlign: 'center', marginBottom: 40 }}>ClickSaver vs manual management vs popular alternatives</p>

          <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 18, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,.04)' }}>
            {/* Header */}
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              <div style={{ padding: '16px 24px', fontSize: 12, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>Feature</div>
              {[
                { name: 'ClickSaver', highlight: true },
                { name: 'ClickCease', highlight: false },
                { name: 'FraudBlocker', highlight: false },
                { name: 'Manual', highlight: false },
              ].map((h, i) => (
                <div key={i} style={{ padding: '16px 12px', fontSize: 13, fontWeight: 700, color: h.highlight ? '#2563eb' : '#475569', textAlign: 'center' }}>{h.name}</div>
              ))}
            </div>
            {COMPARE.map((row, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr', borderBottom: i < COMPARE.length - 1 ? '1px solid #f1f5f9' : 'none', background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
                <div style={{ padding: '13px 24px', fontSize: 13, color: '#475569' }}>{row.feature}</div>
                {[row.cs, row.cc, row.fb, row.manual].map((v, j) => (
                  <div key={j} style={{ padding: '13px 12px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', background: j === 0 ? 'rgba(37,99,235,0.03)' : 'transparent' }}>
                    <Cell v={v} />
                  </div>
                ))}
              </div>
            ))}
          </div>
          <p style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', marginTop: 16 }}>Competitor information based on publicly available pricing and feature pages as of April 2026.</p>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '60px 24px 80px', textAlign: 'center' }}>
        <h2 style={{ fontSize: 32, fontWeight: 800, letterSpacing: '-1px', marginBottom: 14 }}>Ready to try ClickSaver?</h2>
        <p style={{ fontSize: 16, color: '#64748b', marginBottom: 28 }}>7-day free trial. No credit card required.</p>
        <Link to="/register" style={{ background: '#2563eb', color: '#fff', textDecoration: 'none', padding: '14px 36px', borderRadius: 12, fontSize: 16, fontWeight: 700, boxShadow: '0 4px 16px rgba(37,99,235,.35)' }}>Start Free Trial →</Link>
      </section>
    </MarketingLayout>
  );
}
